import { ICreateAnnualPayload } from '../../page/annuals/annuals.types';
import { IAnnual } from '../../resource/annuals/annuals.types';
import { IApiRequestConfig } from '../api.types';

export const getAnnualsApi = (): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'getAnnualsApi',
  uri: 'json',
  action: `annuals`,
  method: 'get',
  v2: true,
});

export const createAnnualApi = (payload: ICreateAnnualPayload): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'createAnnualApi',
  uri: 'json',
  action: `annuals`,
  method: 'post',
  data: payload,
  v2: true,
});

export const updateAnnualApi = (
  annualId: IAnnual['id'],
  payload: ICreateAnnualPayload,
): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'updateAnnualApi',
  uri: 'json',
  action: `annuals/${annualId}`,
  method: 'put',
  data: payload,
  v2: true,
});

export const deleteAnnualApi = (annualId: IAnnual['id']): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'deleteAnnualApi',
  uri: 'json',
  action: `annuals/${annualId}`,
  method: 'delete',
  v2: true,
});
